import { backOfficeEnv } from '@cargoflow/env/back-office'
import { createAuthClient } from 'better-auth/react'

export const authClient = createAuthClient({
  baseURL: backOfficeEnv.BACK_API_URL,
})

export const { signIn, signOut, useSession, getSession } = authClient
